$(function() {
  $('.kef-cms-accordion a[href*="#"], .template-article a[href*="#"]').on('click', function(e) {
    var _t = $(this),
        anchor = _t.attr('href'),
        el = $(anchor);
    if (el.length == 0) return;
    var pos = Math.ceil(el.offset().top);

		var h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height').replace('px', ''));
		if ($(window).width() < 1024 && document.body.classList.contains('scroll-btm')) {
			h = parseInt(getComputedStyle(document.body).getPropertyValue('--header-v3-height').replace('px', ''))
		}
		if ($(window).width() < 1024 && Math.ceil($(window).scrollTop()) > pos) {
			h += parseInt(getComputedStyle(document.body).getPropertyValue('--header-announcement-height').replace('px', ''));
		}

    pos -= h;
    pos -= $(window).width() > 480 ? 40 : 0;
    
    $('body, html').animate({
      scrollTop: pos
    }, 500);

    e.preventDefault();
  });
});